module.exports = __webpack_public_path__ + "img/two-step-verification.d6042083.svg";